import { useEffect, useState } from 'react';

// Keeps an expensive derived value (a filtered list) off the keystroke path.
// The input stays fully controlled and repaints instantly; only this delayed
// copy of the term drives the filtering, so typing "smith" runs one pass
// instead of five. Same idea as the 200ms debounce in AddressAutocomplete.
const useDebouncedValue = (value, delay = 200) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
};

export default useDebouncedValue;
